import { createAction } from 'redux-actions'

import * as types from './types'

export const storeGames = createAction(types.STORE_GAMES)

export const storeGameProps = createAction(
  types.STORE_GAME_PROPS,
  (id, props) => ({
    id,
    props,
  })
)

export const clearGameOptions = createAction(types.CLEAR_GAME_OPTIONS, id => ({
  id,
}))

export const clearQueryResults = createAction(types.CLEAR_QUERY_RESULTS)

export const appendQueryResults = createAction(types.APPEND_QUERY_RESULTS)

export const replaceQueryResults = createAction(types.REPLACE_QUERY_RESULTS)

export const storeQueryOffset = createAction(types.STORE_QUERY_OFFSET)

export const updateFilterGameType = createAction(types.UPDATE_FILTER_GAME_TYPE)

export const updateFilterBetRange = createAction(types.UPDATE_FILTER_BET_RANGE)
